import React from 'react';

export default {
  title: 'Cash Drawer',
  hidden: true,
  path: '/hardware/integrations/:level/:level_id/cashDrawer',
  component: () => (
    <div className="jumbotron">
      <p>Coming soon...</p>
    </div>
  ),
};
